<template>
  <div class="page-result">
    <c-left-side-bar :step="4" />
    <n-loader :loading="$var('load')"></n-loader>
    <c-modal-message :hide.sync="hide" :modal-type="modalType" :state.sync="state"></c-modal-message>
    <div class="mid-container">
      <div v-if="!timerCheck && !znanyCheck" class="mid-side">
        <c-mid-head back-route="kln-timer-info" h1="Оценки" />
        <div class="answers-block">
          <div class="answers-block-head">
            <h2>Вопросы</h2>
            <h3>{{ category.title }}</h3>
          </div>
          <div class="answers-block-body">
            <ul class="answers-list">
              <li v-for="item in questions" v-if="!item.parentId" :key="item.id" class="answers-row">
                <div class="answer">
                  <div v-if="!item.isMemo" class="image-place">
                    <img v-if="checkState(item.id) === 'ignored'" :src="iconIgnored" alt="">
                    <img v-else :src="checkState(item.id) === 'correct' ? iconCorrect : iconIncorrect" alt="">
                  </div>
                  <p class="answer-title" :class="{'memo': item.isMemo}">{{ item.title }}</p>
                </div>
                <div v-for="sub in item.subquestions" class="sub-answers">
                  <div v-if="!sub.isMemo" class="image-place">
                    <img v-if="checkState(sub.id) === 'ignored'" :src="iconIgnored" alt="">
                    <img v-else :src="checkState(sub.id) === 'correct' ? iconCorrect : iconIncorrect" alt="">
                  </div>
                  <p class="answer-title" :class="{'memo': sub.isMemo}">{{ sub.title }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="timer.formula === 1">
        <div v-if="timerCheck" class="mid-side">
          <div class="mid-top" style="display: block">
            <c-mid-head back-route="kln-timer-info" h1="Оценки" />
            <div class="answers-block">
              <div class="answers-block-head">
                <h2>Таймеры</h2>
              </div>
              <div class="answers-block-body">
                <table class="timer-table">
                  <thead>
                    <tr>
                      <th>10:1</th>
                      <th>4:1</th>
                      <th>3:1</th>
                      <th>MFY</th>
                      <th>Финальный балл</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="timer && result.timer">
                      <td>{{ timer?.averageTimeOne }} с.</td>
                      <td>{{ timer?.averageTimeTwo }} с.</td>
                      <td>{{ timer?.averageTimeThree }} с.</td>
                      <td>{{ timer?.averageTimeFour }} с.</td>
                      <td>{{ timer?.finalScore }}%</td>
                    </tr>
                    <tr v-else>
                      <td colspan="5">Нет данных</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="timer.formula === 2">
        <div v-if="timerCheck" class="mid-side">
          <div class="mid-top" style="display: block">
            <c-mid-head back-route="kln-timer-info" h1="Оценки" />
            <div class="answers-block">
              <div class="answers-block-head">
                <h2>Таймеры</h2>
              </div>
              <div class="answers-block-body">
                <table class="timer-table">
                  <thead>
                    <tr>
                      <th>10:1</th>
                      <th>4:1</th>
                      <th>3:1</th>
                      <th>MFY</th>
                      <th>Финальный балл</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="timer && result.timer">
                      <td>{{ timer?.averageTimeOne }} с.</td>
                      <td>{{ timer?.averageTimeTwo }} с.</td>
                      <td>{{ timer?.averageTimeThree }} с.</td>
                      <td>{{ timer?.averageTimeFour }} с.</td>
                      <td>{{ timer?.finalScore }}%</td>
                    </tr>
                    <tr v-else>
                      <td colspan="5">Нет данных</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="timer.formula === 3">
        <div v-if="timerCheck" class="mid-side">
          <div class="mid-top" style="display: block">
            <c-mid-head back-route="kln-timer-info" h1="Оценки" />
            <div class="answers-block">
              <div class="answers-block-head">
                <h2>Таймеры</h2>
              </div>
              <div class="answers-block-body">
                <table class="timer-table">
                  <thead>
                    <tr>
                      <th>Прилавок</th>
                      <th>Drive</th>
                      <th>Финальный балл</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="timer && result.timer">
                      <td>{{ timer?.averageTimeFour }} с.</td>
                      <td>{{ timer?.averageTimeFive }} с.</td>
                      <td>{{ timer?.finalScore }}%</td>
                    </tr>
                    <tr v-else>
                      <td colspan="5">Нет данных</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="timer.formula === 4">
        <div v-if="timerCheck" class="mid-side">
          <div class="mid-top" style="display: block">
            <c-mid-head back-route="kln-timer-info" h1="Оценки" />
            <div class="answers-block">
              <div class="answers-block-head">
                <h2>Таймеры</h2>
              </div>
              <div class="answers-block-body">
                <table class="timer-table">
                  <thead>
                    <tr>
                      <th>Прилавок</th>
                      <th>Финальный балл</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="timer && result.timer">
                      <td>{{ timer?.averageTimeFour }} с.</td>
                      <td>{{ timer?.finalScore }}%</td>
                    </tr>
                    <tr v-else>
                      <td colspan="5">Нет данных</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="timer.formula === 5">
        <div v-if="timerCheck" class="mid-side">
          <div class="mid-top" style="display: block">
            <c-mid-head back-route="kln-timer-info" h1="Оценки" />
            <div class="answers-block">
              <div class="answers-block-head">
                <h2>Таймеры</h2>
              </div>
              <div class="answers-block-body">
                <table class="timer-table">
                  <thead>
                    <tr>
                      <th>Прилавок</th>
                      <th>MFY</th>
                      <th>Производительность</th>
                      <th>Финальный балл</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="timer && result.timer">
                      <td>{{ timer?.averageTimeFour }} с.</td>
                      <td>{{ timer?.averageTimeFive }} с.</td>
                      <td>{{ timer?.grade }}%</td>
                      <td>{{ timer?.finalScore }}%</td>
                    </tr>
                    <tr v-else>
                      <td colspan="5">Нет данных</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="timer.formula === 6">
        <div v-if="timerCheck" class="mid-side">
          <div class="mid-top" style="display: block">
            <c-mid-head back-route="kln-timer-info" h1="Оценки" />
            <div class="answers-block">
              <div class="answers-block-head">
                <h2>Таймеры</h2>
              </div>
              <div class="answers-block-body">
                <table class="timer-table">
                  <thead>
                    <tr>
                      <th>Прилавок</th>
                      <th>MFY</th>
                      <th>Delivery</th>
                      <th>Производительность</th>
                      <th>Финальный балл</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="timer && result.timer">
                      <td>{{ timer?.averageTimeFour }} с.</td>
                      <td>{{ timer?.averageTimeFive }} с.</td>
                      <td>{{ timer?.averageTimeThree }} с.</td>
                      <td>{{ timer?.grade }}%</td>
                      <td>{{ timer?.finalScore }}%</td>
                    </tr>
                    <tr v-else>
                      <td colspan="5">Нет данных</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="timer.formula === 7">
        <div v-if="timerCheck" class="mid-side">
          <div class="mid-top" style="display: block">
            <c-mid-head back-route="kln-timer-info" h1="Оценки" />
            <div class="answers-block">
              <div class="answers-block-head">
                <h2>Таймеры</h2>
              </div>
              <div class="answers-block-body">
                <table class="timer-table">
                  <thead>
                    <tr>
                      <th>Прилавок</th>
                      <th>Cafe</th>
                      <th>MFY</th>
                      <th>Производительность</th>
                      <th>Финальный балл</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="timer && result.timer">
                      <td>{{ timer?.averageTimeFour }} с.</td>
                      <td>{{ timer?.averageTimeThree }} с.</td>
                      <td>{{ timer?.averageTimeFive }} с.</td>
                      <td>{{ timer?.grade }}%</td>
                      <td>{{ timer?.finalScore }}%</td>
                    </tr>
                    <tr v-else>
                      <td colspan="5">Нет данных</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="timer.formula === 8">
        <div v-if="timerCheck" class="mid-side">
          <div class="mid-top" style="display: block">
            <c-mid-head back-route="kln-timer-info" h1="Оценки" />
            <div class="answers-block">
              <div class="answers-block-head">
                <h2>Таймеры</h2>
              </div>
              <div class="answers-block-body">
                <table class="timer-table">
                  <thead>
                    <tr>
                      <th>Прилавок</th>
                      <th>Drive</th>
                      <th>Cafe</th>
                      <th>MFY</th>
                      <th>Delivery</th>
                      <th>Производительность</th>
                      <th>Финальный балл</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="timer && result.timer">
                      <td>{{ timer?.averageTimeOne }} с.</td>
                      <td>{{ timer?.averageTimeTwo }} с.</td>
                      <td>{{ timer?.averageTimeThree }} с.</td>
                      <td>{{ timer?.averageTimeFour }} с.</td>
                      <td>{{ timer?.averageTimeFive }} с.</td>
                      <td>{{ timer?.grade }}%</td>

                      <td>{{ timer?.finalScore }}%</td>
                    </tr>
                    <tr v-else>
                      <td colspan="5">Нет данных</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="znanyCheck" class="mid-side">
        <c-mid-head back-route="kln-timer-info" h1="Оценки" />
        <div class="mid-top" style="display: block">
          <div class="answers-block-head">
            <h2>Теоретические знания менеджера</h2>
          </div>
<!--          <c-mid-head h1="Теоретические знания менеджера"/>-->
          <div
            v-for="category in categories"
            :key="category.name"
            class="category-block"
          >
            <h4>{{ category.title }}</h4>

            <table class="question-table">
              <thead>
                <tr>
                  <th>Вопрос</th>
                  <th class="col-check">Да</th>
                  <th class="col-check">Нет</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(q, index) in category.questions" :key="index">

                  <!-- ТЕКСТ -->
                  <td>
                    <div class="question-text">
                      {{ q.title || '—' }}
                    </div>
                  </td>

                  <!-- ДА -->
                  <td class="center">
                    <img :src="q.answer === true ? iconCorrect : iconIncorrect" alt="">
                  </td>

                  <!-- НЕТ -->
                  <td class="center">
                    <img :src="q.answer === false ? iconCorrect : iconIncorrect" alt="">
                  </td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="right-container">
      <div class="right-side">
        <div v-if="user.fullName" class="user-info">
          <h3>{{ user.fullName }}</h3>
          <p>Табельный номер: {{ user.personnelNumber }}</p>
        </div>
        <div v-else class="user-info">
          <h3>Гость</h3>
        </div>
        <div class="results">
          <h3>Итоги аттестации</h3>
          <ul>
            <li class="kln-stats">
              <p>Дата проведения оценки</p>
              <p>{{ $app.date.format(result.createdAt, 'date') }}</p>
            </li>
            <li class="kln-stats">
              <p>Результат:</p>
              <p>{{ Math.round(result.timer?.finalScore) }}%</p>
            </li>
            <li class="kln-stats">
              <p>Общее количество вопросов:</p>
              <p>{{ result.questionsCount }}</p>
            </li>
            <li v-if="result.declineCount > 0" class="kln-stats">
              <p>Количество отклонений:</p>
              <p>{{ result.declineCount }}</p>
            </li>
            <li v-if="result.status === 'finished'" class="kln-stats">
              <p>Награда:</p>
              <p>{{ result.reward || 0 }}</p>
            </li>
          </ul>
        </div>
        <div class="sections">
          <h3>Разделы:</h3>
          <ul class="section-list">
            <li v-for="item in quizzes" :key="item.id" class="section-row" :class="{'active' : isActive(item) && !timerCheck && !znanyCheck}" @click="selectQuiz(item)">
              <div class="icon-place">
<!--                <div class="image-place">-->
<!--                  <img :src="item.image" alt="" class="section-img">-->
<!--                </div>-->
              </div>
              <div class="section-info">
                <p>{{ category.title }}</p>
                <p>{{ item.title }}</p>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="timer">
          <div class="sections">
            <h3>Таймер:</h3>
            <ul class="section-list">
              <li v-for="item in quizzes2" :key="item.id" class="section-row" :class="{'active' : timerCheck}" @click="checkTimer">
                <div class="icon-place">
                  <div class="image-place">
                    <img :src="timerIcon" alt="" class="section-img">
                  </div>
                </div>
                <div class="section-info">
                  <p></p>
                  <p>Таймер</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <div class="sections">
            <h3>ТЗМ:</h3>
            <ul class="section-list">
              <li v-for="item in quizzes2" :key="item.id" class="section-row" :class="{'active' : znanyCheck}" @click="checkZnany">
                <div class="icon-place">
                  <div class="image-place">
                    <img :src="timerIcon" alt="" class="section-img">
                  </div>
                </div>
                <div class="section-info">
                  <p></p>
                  <p>Теоритические знания менеджера</p>
                </div>
              </li>
            </ul>
          </div>
        </div>


        <div v-if="result?.status === 'declined'" class="accept-buttons">
          <n-button
            flat class="accept"
            @click="remake">
            Править
          </n-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import categoryIcon from 'assets/categoryIcon/culture-icon.png'
import iconCorrect from 'assets/icon-correct.svg'
import iconIncorrect from 'assets/icon-incorrect.svg'
import iconIgnored from 'assets/icon-deleted.svg'
import timerIcon from 'assets/timer_icon.svg'


export default {
  name: 'PageInfo',
  data() {
    return {
      categoryIcon,
      result: {},
      user: {},
      quizzes: [],
      quiz: {},
      quizzes2: [
        { id: 1, title: 'timer', },
      ],
      timer: {},
      znanyCheck: false,
      timerCheck: false,
      category: {},
      categories: [
        {
          name: 0,
          title: '',
          questions: [
            { title: '', answer: null },
            { title: '', answer: null },
            { title: '', answer: null },
          ],
        },
        {
          name: 0,
          title: '',
          questions: [
            { title: '', answer: null },
            { title: '', answer: null },
            { title: '', answer: null },
          ],
        },
        {
          name: 0,
          title: '',
          questions: [
            { title: '', answer: null },
            { title: '', answer: null },
            { title: '', answer: null },
          ],
        },
        {
          name: 0,
          title: '',
          questions: [
            { title: '', answer: null },
            { title: '', answer: null },
            { title: '', answer: null },
          ],
        },
      ],
      answers: {},
      questions: [],
      isUnAccepted: true,
      modalType: 'accept',
      hide: true,
      state: '',
      iconCorrect,
      iconIgnored,
      iconIncorrect,
      timerIcon,
    }
  },
  computed: {
    resultId() {
      return this.$route.query.resultId
    },
  },
  watch: {
    state() {
      if (this.state === 'accept') {
        this.accept()
      }
      if (this.state === 'decline') {
        this.decline()
      }
      this.state = ''
    },
  },
  created() {
    this.loadResult()
  },
  methods: {
    loadResult() {
      this.$var('load', true)
      $api.timerresults.get(this.resultId).all().with('answers').with('timer').with('theoryQuestion').with('theoryManagerCategories').then((response) => {
        this.result = response.data.content
        if (response.data.content.timer) {
          this.timer = response.data.content.timer
        }

        const theoryQuestions = this.result.theoryQuestion || []
        const theoryCategories = this.result.theoryManagerCategories || []

        this.categories = theoryCategories.map(category => {
          // все вопросы этой категории
          const questionsForCategory = theoryQuestions.filter(
              q => Number(q.managerCategoryId) === Number(category.id)
          )

          return {
            name: category.id,
            title: category.title,
            questions: [0, 1, 2].map(i => {
              const q = questionsForCategory.find(q => Number(q.order) === i)

              return {
                title: q?.title || '',
                answer: q?.answer ?? null
              }
            })
          }
        })
        this.isUnAccepted = this.result.status === 'unaccepted'
        if (this.result.userId) {
          this.loadUser()
        }
        this.loadQuizzes()
        this.loadCategory()
        this.getAnswers()
      }).finally(() => {
      })
    },
    loadUser() {
      $api.users.get(this.result.userId).then((response) => {
        this.user = response.data.content
      })
    },
    checkTimer() {
      this.znanyCheck= false
      this.timerCheck= !this.timerCheck
    },
    checkZnany() {
      this.timerCheck= false
      this.znanyCheck= !this.znanyCheck
    },
    remake() {
      this.$var('load', true)
      $api.timerresults.remake(this.resultId, { status: 'interrupted', }).then(() => {
        this.$router.push({ name: 'kln-timer-quizzes', query: { categoryId: this.result.categoryId, resultId: this.resultId, }, })
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadQuizzes() {
      $api.timerquizzes.get(this.result.categoryId).all().then((response) => {
        this.quizzes = response.data.content
        this.quiz = this.quizzes[0]
        this.loadQuestions()
      })
    },
    loadCategory() {
      $api.timercategories.get(this.result.categoryId).all().then((response) => {
        this.category = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    getAnswers() {
      $n.map(this.result.answers, (elem) => {
        this.answers = {
          ...this.answers,
          [elem.questionId+'']: {
            value: elem.value,
            ignored: elem.ignored,
          },
        }
      })
    },
    loadQuestions() {
      $api.timerquestions.get(this.quiz.id).all().with('subquestions').then((response) => {
        this.questions = response.data.content
      })
    },
    checkState(questionId) {
      questionId = questionId+''
      if (this.answers[questionId]) {
        return this.answers[questionId].value && !this.answers[questionId].ignored ? 'correct' : this.answers[questionId].ignored ? 'ignored' : 'incorrect'
      } else {
        return 'incorrect'
      }
    },
    selectQuiz(newQuiz) {
      this.znanyCheck= false
      this.timerCheck = false
      this.quiz = newQuiz
      this.loadQuestions()
    },
    isActive(item) {
      return this.quiz.id === item.id
    },
    accept() {
      $api.timerresults.patch(this.result.id, { status: 'finished', }).then(() => {
        this.$router.push({ name: 'kln-timer-info', })
      })
    },
    decline() {
      $api.timerresults.patch(this.result.id, { status: 'declined', }).then(() => {
        this.$router.push({ name: 'kln-timer-info', })
      })
    },
    cancel() {
      this.$router.push({ name: 'kln-timer-info', })
    },
    showModal(modalType) {
      this.modalType = modalType
      this.hide = false
    },
  },
}
</script>

<style lang="scss" scoped>
.page-result {
  display: flex;
  min-height: 100vh;

  .mid-container {
    padding: 40px 20px 20px 20px;
    width: 100%;
    position: relative;

    .mid-side {
      .answers-block-head {
        h2 {
          color: var(--secondary);
          font-size: 2em;
          font-weight: bold;
          margin: 22px 0 0 0;
          padding: 0;
        }
        h3 {
          margin: 8px 0 0 0;
          padding: 0;
          color: #969FA8;
          font-size: 1.2em;
        }
      }
      .mid-top{
        .question-table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 15px;

          th, td {
            border: 1px solid #ccc;
            padding: 10px;
          }

          th {
            background: #f5f5f5;
            text-align: left;
          }

          .col-check {
            width: 80px;
            text-align: center;
          }

          .center {
            text-align: center;
            img{
              width: 20px;
              height: 20px;
            }
          }
        }

        .question-input {
          width: 100%;
          min-height: 60px;
          resize: vertical;
          border: none;
          outline: none;
          font-size: 14px;
          font-family: inherit;
        }
      }
      .answers-block {
        .answers-block-head {
          h2 {
            color: var(--secondary);
            font-size: 2em;
            font-weight: bold;
            margin: 22px 0 0 0;
            padding: 0;
          }
          h3 {
            margin: 8px 0 0 0;
            padding: 0;
            color: #969FA8;
            font-size: 1.2em;
          }
        }
        .answers-block-body {
          margin: 22px 0 0 0;
          overflow: auto;
          .timer-table {
            width: 100%;
            border-collapse: collapse;
          }

          .timer-table th,
          .timer-table td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: center;
          }

          .timer-table th {
            background-color: #f4f4f4;
          }
          .answers-list {
            list-style: none;
            padding: 0;

            .answers-row {

              .answer-title {
                flex: 2;
              }
              max-width: 440px;
              .answer {
                display: flex;
                align-items: center;
                margin-bottom: 28px;
                position: relative;
                .image-place {
                  width: 20px;
                  height: 20px;
                  margin-right: 15px;
                  flex-shrink: 0;
                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                  }
                }

                &:before {
                  position: absolute;
                  content: '';
                  width: 70%;
                  height: 1px;
                  background-color: #E9E9EC;
                  left: 35px;
                  bottom: -15px;
                }

                .answer-state {
                  position: relative;
                  width: 20px;
                  height: 20px;
                  background-color: var(--primary);
                  color: var(--primary);
                  border-radius: 4px;
                  margin-right: 15px;
                  &.correct {
                    &::before {
                      position: absolute;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      content: '\2713';
                      font-size: 1.0em;
                      width: 100%;
                      height: 100%;
                      color: #ffffff;
                      left: 0;
                      right: 0;
                      bottom: 0;
                      top: 0;
                    }
                  }
                  &.ignored {
                    background-color: #DB0007;
                    &::before {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      position: absolute;
                      content: '\00D7';
                      font-size: 1.6em;
                      width: 100%;
                      height: 100%;
                      color: #ffffff;
                      left: 0;
                      right: 0;
                      top: 0;
                      bottom: 0;
                    }
                  }
                  &.incorrect {
                    background-color: #E2E4EC;
                    &::before {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      position: absolute;
                      content: '-';
                      font-size: 2.2em;
                      color: #ffffff;
                      left: 0;
                      right: 0;
                      top: -5px;
                      bottom: 0;
                    }
                  }
                }
              }
              .sub-answers {
                display: flex;
                align-items: center;
                padding: 10px 35px;
                margin-bottom: 28px;
                position: relative;
                .image-place {
                  width: 20px;
                  height: 20px;
                  margin-right: 15px;
                  flex-shrink: 0;
                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                  }
                }

                &:before {
                  position: absolute;
                  content: '';
                  width: 70%;
                  height: 1px;
                  background-color: #E9E9EC;
                  left: 35px;
                  bottom: -15px;
                }

                .answer-state {
                  position: relative;
                  width: 20px;
                  height: 20px;
                  background-color: var(--primary);
                  color: var(--primary);
                  border-radius: 4px;
                  margin-right: 15px;
                  &.correct {
                    &::before {
                      position: absolute;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      content: '\2713';
                      font-size: 1.0em;
                      width: 100%;
                      height: 100%;
                      color: #ffffff;
                      left: 0;
                      right: 0;
                      bottom: 0;
                      top: 0;
                    }
                  }
                  &.ignored {
                    background-color: #DB0007;
                    &::before {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      position: absolute;
                      content: '\00D7';
                      font-size: 1.6em;
                      width: 100%;
                      height: 100%;
                      color: #ffffff;
                      left: 0;
                      right: 0;
                      top: 0;
                      bottom: 0;
                    }
                  }
                  &.incorrect {
                    background-color: #E2E4EC;
                    &::before {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      position: absolute;
                      content: '-';
                      font-size: 2.2em;
                      color: #ffffff;
                      left: 0;
                      right: 0;
                      top: -5px;
                      bottom: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .right-container {
    padding: 40px 20px 0 20px;
    background-color: #FCFCFC;
    position: relative;
    min-width: 460px;

    .right-side {
      position: relative;
      height: 100%;

      .user-info {
        margin-bottom: 28px;
        h3 {
          font-size: 1.05em;
          color: var(--secondary)
        }
        p {
          color: #6D6F7B;
          font-size: 0.8em;
        }
      }

      .results {
        ul {
          list-style: none;
          margin: 0;
          padding: 0;
        }
        h3 {
          font-size: 1.5em;
          color: var(--secondary);
          font-weight: bold;
          margin-bottom: 11px;
        }
        .kln-stats {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 40px;
          p {
            color: var(--secondary);
            font-size: 1.05em;
            &:first-child {
              &::before {
                content: '';
                height: 1px;
                width: 390px;
                position: absolute;
                background-color: #E9E9EC;
                left: 0;
                bottom: -19px;
              }
            }
          }
        }
      }

      .sections {
        margin-top: 24px;
        h3 {
          font-size: 1.05em;
          color: #000000;
          font-weight: bold;
          margin-bottom: 28px;
        }
        .section-list {
          list-style: none;
          padding: 0;
          margin: 0;
          overflow: auto;
          max-height: calc(100vh/3);
          .section-row {
            cursor: pointer;
            display: flex;
            margin-bottom: 25px;
            border-radius: 12px;
            &.active {
              background-color: rgba(38, 79, 54, 0.2);
            }
            .icon-place {
              width: 64px;
              height: 64px;
              background-color: #F6F6F6;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 12px;
              margin-right: 20px;
              .image-place {
                width: 44px;
                height: 44px;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  aspect-ratio: auto;
                }
              }
            }
            .section-info {
              p{
                font-size: 1.1em;
                color: var(--secondary);
                &:first-child{
                  color: #626C77;
                  font-size: 0.9em;
                }
              }
            }
          }
        }
      }

      .accept-buttons {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 29px;

        .accept{
          color: var(--secondary);
          font-size: 1.1em;
          width: 190px;
          height: 50px;
          margin-right: 10px;
          background-color: #F2F3F7;
          border-radius: 8px;
        }

        .cancel{
          color: #DB0007;
          font-size: 1.1em;
          width: 190px;
          height: 50px;
          background-color: #F2F3F7;
          border-radius: 8px;
        }
      }
    }
  }
  .memo {
    font-style: italic;
  }
  h3 {
    margin: 0;
    padding: 0;
  }
  p {
    margin: 0;
    padding: 0;
  }
}
</style>
